import HeadTittle from '../../../components/HeadTittle';
import { Box } from '@mui/material';
import ButtonAction from '../../../components/buttons/ButtonAction';
import {
    AddIcon, EditIcon,
    IconCanceledByVisitorCard, TrashOutlineIcon
} from '../../../components/buttons/IconButtons';
import StepperTabs from '../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../components/StepperTabs/StepTab';
import { ReservationsMainApp } from './Functionality/ReservationsMainApp';
import { TAB_PERMISSION_RESERVATIONS, TABS_RESERVATIONS } from './Model/Model';
import routes from '../../../Routes/routes';
import ExportDataBtn from '../../../components/buttons/ExportDataBtn';
import {ACTION_MODEL} from '../../../Helpers/ActionModel';
import Manage from "./Manage";
import Bookings from "./Bookings";
import {permissionObj} from "../../../Helpers/permission";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 */
const ReservationsMain = () => {

    const {
        reservationRef,
        option,
        moduleId,
        permission,
        steps,
        activeStep, setActiveStep,
        subView,setSubView,
        manageRef,
        selectedList, setSelectedList,
        search, setSearch,
        simpleSearch, setSimpleSearch,
        sendSimpleSearch, setSendSimpleSearch,
        bodyForExport, setBodyForExport,
        searchElement, setSearchElement,
        DEV,
        handleStepChange,
        permissionButtons,
        handleCreate,
        handleUpdate,
        navigate
    } = ReservationsMainApp();


    if (!DEV &&
        !permission?.includes(permissionObj?.WEB_EVENT_READ) &&
        !permission?.includes(permissionObj?.WEB_EVENT_STATUS_READ) &&
        !permission?.includes(permissionObj?.WEB_EVENT_MANAGE_READ)
    ) {
        navigate(routes.forbidden);
    }

    return (
        <>
            <HeadTittle name={'reservations'}>
                <Box className='d-flex gap-2 justify-content-end align-items-center mb-2'>

                    {permissionButtons(TAB_PERMISSION_RESERVATIONS(subView).EXPORT) &&
                        (
                            <ExportDataBtn
                                id="btn_rm_export"
                                moduleId={moduleId}
                                body={bodyForExport}
                                search={search}
                                option={option}
                                searchElement={search ? searchElement : undefined}
                            />
                        )
                    }

                    {permissionButtons(TAB_PERMISSION_RESERVATIONS(subView).CREATE) && (
                        <ButtonAction
                            id='btn_rm_create'
                            name={'create'}
                            className='btn-icon-add'
                            Icon={AddIcon}
                            onClick={() => {
                                handleCreate();
                            }}
                        />
                    )}
                    {permissionButtons(TAB_PERMISSION_RESERVATIONS(subView).UPDATE) && (
                        <ButtonAction
                            id={"btn_rm_update"}
                            name='update'
                            className={`btn-icon-edit`}
                            Icon={EditIcon}
                            onClick={()=>{
                                handleUpdate();
                            }}
                        />
                    )}

                    {permissionButtons(TAB_PERMISSION_RESERVATIONS(subView).CANCEL) && (
                        <ButtonAction
                            id='btn_rm_cancel'
                            name='cancel'
                            className='btn-icon-delete'
                            disabled={selectedList?.length === 0}
                            Icon={IconCanceledByVisitorCard}
                            onClick={() => {
                                reservationRef.current?.handleShowModals(ACTION_MODEL.CANCEL);
                            }}
                        />
                    )}

                    {permissionButtons(TAB_PERMISSION_RESERVATIONS(subView).DELETE) && (
                        <ButtonAction
                            id='btn_rm_delete'
                            name='delete'
                            className='btn-icon-delete'
                            disabled={selectedList?.length === 0}
                            Icon={TrashOutlineIcon}
                            onClick={() => {
                                reservationRef.current?.handleShowModals(ACTION_MODEL.DELETE);
                            }}
                        />
                    )}

                </Box>

            </HeadTittle>

            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => { }}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_RESERVATIONS.BOOKINGS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_RESERVATIONS.BOOKINGS.INDEX && (
                        <Bookings
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            search={search}
                            setSearch={setSearch}
                            simpleSearch={simpleSearch}
                            setSimpleSearch={setSimpleSearch}
                            sendSimpleSearch={sendSimpleSearch}
                            setSendSimpleSearch={setSendSimpleSearch}
                            bodyForExport={bodyForExport}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            reservationRef={reservationRef}
                            option={option}
                            moduleId={moduleId}
                            subView={subView}
                            setSubView={setSubView}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_RESERVATIONS.MANAGE.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_RESERVATIONS.MANAGE.INDEX && (
                        <Manage
                            subView={subView}
                            setSubView={setSubView}
                            ref={manageRef}
                        />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
}

export default ReservationsMain;
